import { axios } from "../../../../../../Global";
import { setAppError } from "../../../../../../store/userSlice";

const token = localStorage.getItem("token");

export const fetchJobOrder = async (
  projectId,
  setJobOrderData,
  setLoading,
  dispatch
) => {
  setLoading(true);
  try {
    const res = await axios.get(
      `/dashboard/project-job-order-list/${projectId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.status == 200) {
      setLoading(false);
      setJobOrderData(res.data.data);
    }
  } catch (error) {
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
  }
};
